import { render, staticRenderFns } from "./billGame.vue?vue&type=template&id=5e5d01f6&scoped=true"
import script from "./billGame.vue?vue&type=script&lang=js"
export * from "./billGame.vue?vue&type=script&lang=js"
import style0 from "./billGame.vue?vue&type=style&index=0&id=5e5d01f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d01f6",
  null
  
)

export default component.exports